import { Component, inject, InjectionToken } from '@angular/core';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { SidePanelComponent } from '@fullyops/shared/components/side-panel/side-panel.component';
import { MaterialModule } from '@fullyops/shared/material.module';
import { normalizeForSearch } from '@fullyops/shared/normalize-for-search';
import { I18NextCapPipe } from 'angular-i18next';

export interface AssetCategorySidebarInputs {
  /** Names already taken, as returned by {@link normalizeForSearch}. */
  existingNames: ReadonlySet<string>;
  /** Opened on top of another panel, which it goes back to. */
  nested?: boolean;
  onSave(name: string): void;
  onCancel(): void;
}

export const ASSET_CATEGORY_SIDEBAR_TOKEN =
  new InjectionToken<AssetCategorySidebarInputs>(
    'asset-category-sidebar-inputs',
  );

@Component({
  selector: 'fo-asset-category-sidebar',
  templateUrl: './asset-category-sidebar.component.html',
  styleUrl: './asset-category-sidebar.component.scss',
  imports: [
    MaterialModule,
    // NgForm, for ngSubmit: without it the form submits natively and reloads the page.
    FormsModule,
    ReactiveFormsModule,
    I18NextCapPipe,
    SidePanelComponent,
  ],
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline' },
    },
  ],
})
export class AssetCategorySidebarComponent {
  protected inputs = inject(ASSET_CATEGORY_SIDEBAR_TOKEN);

  protected nameControl = new FormControl('', {
    nonNullable: true,
    validators: [
      Validators.required,
      (ctl) =>
        this.inputs.existingNames.has(normalizeForSearch(ctl.value.trim()))
          ? { error: 'error:categoryAlreadyExists' }
          : null,
    ],
  });

  protected save(): void {
    if (this.nameControl.valid && this.nameControl.value.trim() !== '') {
      this.inputs.onSave(this.nameControl.value.trim());
    } else {
      this.nameControl.markAsTouched();
    }
  }
}
